import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { PowerBIService } from 'src/app/services/power-bi/power-bi.service';
import { AppConstants } from 'src/app/shared/constants/app.contants';
import { AlertService, MessageSeverity } from 'src/app/shared/services/alert.service';

@Component({
  selector: 'app-powerbi-modal',
  templateUrl: './powerbi-modal.component.html',
  styleUrls: ['./powerbi-modal.component.css']
})
export class PowerbiModalComponent implements OnInit {
  powerbiForm: FormGroup;
  headquarterSelect: number;
  headquarters = [];
  edit = false;
  disabledHeadquarter = false;

  constructor(
    public dialogRef: MatDialogRef<PowerbiModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private powerBIService: PowerBIService,
    private spinner: NgxSpinnerService,
    public dialog: MatDialog,
  ) { }

  ngOnInit() {
    this.createForm();
    if(this.data.action == AppConstants.OperationType.UPDATE){
      this.edit = true;
      this.powerbiForm.controls['url'].setValue(this.data.obj.url);
    }
  }

  createForm(){
    this.powerbiForm = this.formBuilder.group({
      url: ['', [Validators.required]]
    })
  }

  get f() { return this.powerbiForm.controls; }

  save(){
    if(this.powerbiForm.valid){
      const payload = {
        url:this.powerbiForm.value["url"],
        idHeadquarter: 0,
        idEnterprise: this.data.idEnterprise,
        idUser: localStorage.getItem(AppConstants.Session.USERID),
        idSystem: this.data.idSystem
      }
      this.spinner.show();
      //if(this.data.action == AppConstants.OperationType.ADD){
        this.powerBIService.create(payload).subscribe(_ => {
          if(!_.message){
            this.alertService.showMessage(AppConstants.TitleModal.CREATE_DASHBOARD, AppConstants.MessageModal.CREATE, MessageSeverity.success);
            this.spinner.hide();
            this.data.result = true;
            this.dialogRef.close(this.data);
          }else{
            this.alertService.showMessage(
              _.message,
              "",
              MessageSeverity.error);
              this.spinner.hide();
          }
        });
     /* }else{
        this.dashboardService.update(payload).subscribe(_ => {
          if(!_.message){
            this.alertService.showMessage(AppConstants.TitleModal.UPDATE_DASHBOARD, AppConstants.MessageModal.UPDATE, MessageSeverity.success);
            this.spinner.hide();
            this.data.result = true;
            this.dialogRef.close(this.data);
          }else{
            this.alertService.showMessage(
              _.message,
              "",
              MessageSeverity.error);
            this.spinner.hide();
          }
        });
      }*/
    }else{
      this.powerbiForm.markAllAsTouched();
    }
  }

  close() {
    this.dialog.closeAll();
  }
}
